module.exports = __webpack_public_path__ + "media/images/flags/1x1/lka-45a053a7ae3df201b741be5a8b38ef96.svg";